import { render } from "./PlanPriceWithCoupon.vue?vue&type=template&id=0f53aae8&scoped=true&ts=true"
import script from "./PlanPriceWithCoupon.vue?vue&type=script&lang=ts"
export * from "./PlanPriceWithCoupon.vue?vue&type=script&lang=ts"

import "./PlanPriceWithCoupon.vue?vue&type=style&index=0&id=0f53aae8&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f53aae8"]])

export default __exports__